import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Color } from 'app/shared/models/class/color/color';
import { Tag, TagType } from 'app/shared/models/class/tags/tag';
import { Universe } from 'app/shared/models/class/universe/universe';
import { ColorService } from 'app/shared/services/color/color.service';
import { TagService } from 'app/shared/services/tag/tag.service';
import { UniverseService } from 'app/shared/services/universe/universe.service';

export interface DialogData {
  type: string;
  title: string;
  action: string;
  tagType: TagType;
  tag: Tag;
}

@Component({
  selector: 'app-open-dialog-add-tag',
  templateUrl: './open-dialog-add-tag.component.html',
  styleUrls: ['./open-dialog-add-tag.component.scss']
})
export class OpenDialogAddTagComponent implements OnInit {

  itemForm: UntypedFormGroup;

  colors: Color[];
  selected: Color;

  universes: Universe[] = [];
  isLoading = false;

  constructor(
    public dialogRef: MatDialogRef<OpenDialogAddTagComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: UntypedFormBuilder,
    private tagsService: TagService,
    private colorService: ColorService,
    private universesSrv: UniverseService
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.initComponent();

  }

  onSubmit(): void {
    switch (this.data.action) {
      case 'add':
        switch (this.data.type) {
          case 'tag':

            const newTag = new Tag(this.data.tagType.tagTypeKey, this.f.item.value, this.selected.colorKey);

            this.tagsService.addTag(newTag).subscribe({
              next: () => this.dialogRef.close()
            });

            break;
          case 'categorie':
            let newCategory = new TagType(this.f.item.value);

            let universes = [];
            this.universes.map(universe => {
              if (this.f.universes.value.includes(universe.universeKey)) {
                universes.push(universe);
              }
            })

            newCategory.universes = universes;

            this.tagsService.addCategoryTagUniverse(newCategory).subscribe({
              next: () => this.dialogRef.close()
            });

            break;

          default:
            break;
        }

        break;

      case 'edit':
        switch (this.data.type) {
          case 'tag':
            const updateTag = new Tag(this.data.tagType.tagTypeKey, this.f.item.value, this.selected.colorKey);
            updateTag.tagKey = this.data.tag.tagKey;

            this.tagsService.addTag(updateTag).subscribe({
              next: () => this.dialogRef.close()
            });

            break;
          case 'categorie':
            let updateCategory = new TagType(this.f.item.value);

            let universes = [];
            this.universes.map(universe => {
              if (this.f.universes.value.includes(universe.universeKey)) {
                universes.push(universe);
              }
            })

            updateCategory.universes = universes;
            updateCategory.tags = this.data.tagType.tags;
            updateCategory.tagTypeKey = this.data.tagType.tagTypeKey;

            this.tagsService.addCategoryTagUniverse(updateCategory).subscribe({
              next: () => this.dialogRef.close()
            });

            break;

          default:
            break;
        }
        break;

      default:
        break;
    }

  }

  private getColors(): void {
    this.colorService.getColors().subscribe({
      next: colors => {
        this.colors = colors;
        this.selected = colors.find(c => c.colorKey === this.data.tag?.colorKey) || colors[0];
        this.initForm();
      }
    });
  }

  private getUniverses(): void {
    this.universesSrv.getUniverse().subscribe({
      next: universes => {
        this.universes = universes;
        this.initForm();
      }
    });
  }

  private initComponent(): void {
    if (this.data.type === 'tag') {
      this.getColors();
    } else if (this.data.type === 'categorie') {
      this.getUniverses();
    }
  }

  get f() {
    return this.itemForm.controls;
  }

  private initForm() {
    let universeKeys = [];
    if (this.data.type === 'categorie' && this.data.tagType?.universes?.length > 0) {
      this.data.tagType?.universes.map(universe => {
        universeKeys.push(universe.universeKey);
      })
    }

    this.itemForm = this.formBuilder.group({
      item: [this.data.type === 'tag' ? this.data.tag?.tagName : this.data.action === 'add' ? '' : this.data.tagType.tagTypeName, Validators.required],
      universes: [this.data.type === 'categorie' ? this.data.action === 'add' ? null : universeKeys : null, this.data.type === 'categorie' ? [Validators.required] : null]
    });

    this.isLoading = false;
  }

}
